import React from "react";
import { Link } from "react-router-dom";
// import { Container } from "react-bootstrap";
// import { Nav } from "react-bootstrap";
// import { Navbar, NavDropdown } from "react-bootstrap";
import "./header.css";
import { CgMathDivide } from "react-icons/cg";
import { BsEnvelopeOpen } from "react-icons/bs";
import { FaEnvelopeOpenText, FaRegUser, FaPowerOff } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";

import { DropdownSubmenu, NavDropdownMenu } from "react-bootstrap-submenu";
import logo from "../../assests/images/WebsiteLogo.png";

import Container from "react-bootstrap/Container";
import "react-bootstrap-submenu/dist/index.css";

const Header = () => {
  const menu = [
    { title: "Home", navigation: "/Home" },
    { title: "Users", navigation: "/UserList" },
    {
      title: "Promo Code",
      navigation: "/PromoList",
    },
    { title: "Banner", navigation: "/Banner" },
    { title: "Provider", navigation: "/provider" },
    { title: "Menu", navigation: "/menu" },
    { title: "Category", navigation: "/category" },
    { title: "Feature Games", navigation: "/featureGames" },
    { title: "Coin Package", navigation: "/coinPackage" },
    { title: "Games", navigation: "/games" },
    { title: "Spinsaga Games", navigation: "/spinsaga-games" },
    { title: "Promo", navigation: "/promo" },
    { title: "Gift Card", navigation: "/gift-card" },
    // { title: "Transaction", navigation: "/redem-transaction" },
    // { title: "Redemption Claim", navigation: "/redemptionClaims" },
    // { title: "Coin Trans", navigation: "/coinTransaction" },
  ];
  const subMenu = [
    { title: "Redeem Transaction", navigation: "/redem-transaction" },
    { title: "Redemption Claim", navigation: "/redemptionClaims" },
    { title: "Coin Transaction", navigation: "/coinTransaction" },
    // {
    //   title: "WithDrawal Payments",
    //   navigation: "/Payments",
    // },
  ];

  const state = useSelector((state) => state);
  const { auth, sidebar } = state;
  let navigate = useNavigate();
  const dispatch = useDispatch();
  function Logout() {
    dispatch({
      type: Actions.LOGOUT,
    });
    sessionStorage.clear();
    navigate("/login");
  }
  function ClearGame() {
    dispatch({
      type: Actions.CLEAR_GAME,
    });

    //window.open("_blank");
  }
  return (
    <div id="header-main">
      <Navbar collapseOnSelect bg="dark" variant="dark">
        <Container>
          <Navbar.Brand onClick={ClearGame}>
            <Link to="/Home" style={{ textDecoration: "none" }}>
              {/* <span className="logo1">Bett</span>
              <span className="logo2">Gaming</span> */}
              <img
                src={logo}
                style={{
                  width: "auto",
                  height: "44px",
                  cursor: "pointer",
                }}
                // className="d-inline-block align-top"
                alt="BettDraft"
              />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav2" />
          <Navbar.Collapse id="responsive-navbar-nav2">
            <Nav className="me-auto"> </Nav>
            {!auth.isAuthenticated && (
              <Nav>
                <Nav.Link
                  eventKey={2}
                  className="login-btn"
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  Log In
                </Nav.Link>
              </Nav>
            )}
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {auth.isAuthenticated && (
        <Navbar
          collapseOnSelect
          expand="lg"
          className="navbar-custom new-navbar custom-navbarnav"
        >
          <Container>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="mr-auto">
                {/* <Nav.Link
                  onClick={() => {
                    navigate("/Home");
                  }}
                >
                  Home
                </Nav.Link>
                <Nav.Link
                  onClick={() => {
                    navigate("/UserList");
                  }}
                >
                  Users
                </Nav.Link> */}

                {/* <Nav.Link
                  onClick={() => {
                    navigate("/Banner");
                  }}
                >
                  Banner
                </Nav.Link> */}
                {menu.map((item) => {
                  return (
                    <Nav.Link
                      onClick={() => {
                        navigate(item.navigation);
                      }}
                    >
                      {item.title}
                    </Nav.Link>
                  );
                })}

                <NavDropdownMenu title="Payments">
                  {subMenu.map((item) => {
                    return (
                      <NavDropdown.Item
                        onClick={() => {
                          navigate(item.navigation);
                        }}
                      >
                        {item.title}
                      </NavDropdown.Item>
                    );
                  })}
                </NavDropdownMenu>

                <Nav.Link className="last-link" onClick={Logout}>
                  QUIT
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      )}
    </div>
  );
};

export default Header;
